(ns kyber.components.composite.footer
  (:require [kyber.components.base.text :refer [body-10]]
            [kyber.components.base.link :refer [link]]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.i18n.core :as i18n]))

(def styles
  {:container
   {:display :flex
    :justify-content :space-between
    :align-items :center
    :background-color (gs [:colors :true-white])
    :border-top "1px solid"
    :border-top-color (gs [:colors :gray-scale-200])
    :padding [(gs [:spacing :p8])
              (gs [:spacing :p16])]

    (gs [:queries :print])
    {:display :none}}

   :archemedx-link
   {:color (gs [:colors :primary-lite-600])}

   :footer-links
   {:list-style :none
    :display :flex
    :align-items :center
    "& > li"
    {:border-left (str "1px solid " (gs [:colors :gray-scale-300]))
     :margin-left (gs [:spacing :p8])
     :padding-left (gs [:spacing :p8])
     "&:first-child" {:border-left :none}
     "& > a" {:color (gs [:colors :primary-lite-600])}}}})

(def classes (styles->classes styles))

(defn footer []
  [:div {:class (:container classes)}
   [body-10 :p
    {:style {:color (gs [:colors :gray-scale-400])
             :margin (gs [:spacing :p0])}}
    [:span
    (i18n/t* ::copyright (.getFullYear (js/Date.)))
     [link {:href "http://www.archemedx.com"
            :class (:archemedx-link classes)} (i18n/t* ::arcx)]
     (i18n/t* ::rights-reserved)]]

   [:ul {:class (:footer-links classes)}
    [:li [link {:href "mailto:support@archemedx.com"} (i18n/t* ::support)]]
    [:li [link {:href "/terms-and-conditions" :target "_blank"} (i18n/t* ::terms)]]
    [:li [link {:href "https://www.archemedx.com/privacy-policy/" :target "_blank"} (i18n/t* ::privacy)]]]])
